module.exports = __webpack_public_path__ + "static/img/file-picture.2a4aea81.svg";